import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useAppSelector } from '@/store/hooks';
import { getPortalUrl } from '../../../../apiServices/paymentApi';
import { Spinner } from '@/components/ui/Spinner';

interface SelectedPackage {
  name: string;
  admins: number;
  price: number;
  storage: number;
  data_transfer: number;
  subscriptionStatus?: string;
  nextPayment?: string;
}

export function AccountSettingsBilling() {
  const selectedPackage = useAppSelector((state) => state.workspace.selectedPackage) as SelectedPackage | null;
  const [portalUrl, setPortalUrl] = useState<string | null>(null);

  useEffect(() => {
    getPortalUrl().then((res: { response: string }) => {
      try {
        new URL(res.response);
        setPortalUrl(res.response);
      } catch {
        // invalid URL
      }
    });
  }, []);

  if (!selectedPackage) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold text-foreground">Billing</h1>
      <div className="space-y-3">
        <Row label="Plan" value={selectedPackage.name} />
        <Row label="Admins" value={String(selectedPackage.admins)} />
        <Row label="Price" value={`${selectedPackage.price} €/month`} />
        <Row label="Storage" value={`${selectedPackage.storage} GB`} />
        <Row label="Data transfer" value={String(selectedPackage.data_transfer)} />
        {selectedPackage.subscriptionStatus && (
          <Row label="Status" value={selectedPackage.subscriptionStatus} />
        )}
        {selectedPackage.nextPayment && (
          <Row label="Next payment" value={format(new Date(selectedPackage.nextPayment), 'dd.MM.yyyy HH:mm')} />
        )}
        {portalUrl && (
          <a
            href={portalUrl}
            className="mt-4 inline-block rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-hover transition-colors"
          >
            Manage subscription
          </a>
        )}
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between border-b border-border-light py-2 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-foreground">{value}</span>
    </div>
  );
}
